import React from 'react';
import { array } from 'prop-types';
import SeoMarkupScript, { breadcrumbFormatter } from '../../../../shared/components/SeoMarkup';

const SeoMarkups = ({ baseUrl, breadcrumbs = [] }) => (
    <div>{!!breadcrumbs.length && <SeoMarkupScript scriptContent={breadcrumbFormatter(breadcrumbs, baseUrl)} />}</div>
);

SeoMarkups.propTypes = {
    breadcrumbs: array,
};

export default SeoMarkups;
